
import { defineComponent, nextTick, ref, watch } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: String,
      default: ''
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },

  setup (props, context) {
    const selfValue = ref()
    const isEdit = ref(false)
    const inputNode = ref()

    function startEdit () {
      selfValue.value = props.value ?? ''
      isEdit.value = true
      nextTick(() => inputNode.value?.focus?.())
    }

    function handleBlur () {
      if (!isEdit.value) return
      isEdit.value = false
      const next = (selfValue.value ?? '').trim()
      if (next !== (props.value ?? '')) {
        context.emit('blur', next)
        return
      }
      selfValue.value = props.value
    }

    watch(() => props.value, (value) => {
      selfValue.value = value
    }, { immediate: true })

    return {
      isEdit,
      inputNode,
      selfValue,
      startEdit,
      handleBlur,
    }
  }
})
